module.exports = __webpack_public_path__ + "img/skkuadra.22840244.png";